'use strict';

export default function extendDeep(dst) {
	angular.forEach(arguments, function (obj) {
		if (!!obj && obj !== dst) {
			angular.forEach(dst, function (value, key) {
				if (dst[key] && typeof dst[key] === 'object' && !Array.isArray(dst[key]) && !(dst[key] instanceof mx.SolutionBuilderAgent.Relation)) {
					extendDeep(dst[key], obj[key]);
				} else if (dst[key] instanceof mx.SolutionBuilderAgent.Relation) {
					dst[key].addedRelations = obj[key].AddedRelations;
					dst[key].removedRelations = obj[key].RemovedRelations;
				} else {
					dst[key] = obj[key];
				}
			});
		}
	});
	return dst;
}
